import React, { Component } from "react";
import { toastContainer } from "../../utils/toast";
import { isMobile } from "../../utils/deviceInfo";
import "./trivia-survey.css";
import {
  Button,
  Row,
  Col,
  Popover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import { CSVLink } from "react-csv";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutRowLines,
  LayoutDataLines,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";
import { BsDownload, BsThreeDots } from "react-icons/bs";
import ReactTooltip from "react-tooltip";

import EmptyTable from "../../components/EmptyTable/EmptyTable";

import { GiOpenTreasureChest } from "react-icons/gi";
import { LuCalendarCheck } from "react-icons/lu";
import ViewSummaryCommon from "../../components/Trivvy/ViewSummarycomon";
import "react-toggle/style.css";

class TriviaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myPendingQuizes: [],
      removeId: false,
      customModalText: null,
      showAll: true,
      pendingCount: 0,
    };
  }

  componentDidMount() {
    console.log("Pending Trivvy");
    const { organizationId } = this.props.user.profile;

    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
        optionsPopover: null,
      });
    } else {
    }

    let that = this;
    this.retrieveMySubmittedQuizes();
  }

  getDataForExportResult = () => {
    const { myPendingQuizes
 } = this.state;
    if (myPendingQuizes && myPendingQuizes.length) {
      const myQuizArray = myPendingQuizes.map((x) => ({
        name: x.triviaId.name || "NA",
        createdOn: x.createdOn
          ? moment(x.createdOn).format("lll")
          : "NA",
        trivvyEndDate: x.triviaId.trivvyEndDate
          ? moment(x.triviaId.trivvyEndDate).format("lll")
          : "NA",
        totalQuestions: x.triviaId.questions.length
          ? `${x.triviaId.questions.length || 0}`
          : "0",
        rewards: x.triviaId.linkedRewards.length || 0,
      }));

      return myQuizArray;
    } else {
      return [];
    }
  };

  retrieveMySubmittedQuizes = (pending = false) => {
    const { sortParams } = this.props;
    const fullUrl = !pending
      ? `${url.getMyPendingTrivvys}?includeAll=true`
      : url.getMyPendingTrivvys;
    axios
      .get(fullUrl)
      .then(({ data }) => {
        const trivvysData = data.data || [];
        const surveyData = trivvysData.filter((e) => e.triviaId && e.triviaId.uploadType == null && !e.isMessaging);
        this.setState({ myPendingQuizes: surveyData });
        let pendingCount = 0;
        if (!pending) {
          pendingCount = surveyData.filter((e) => e.isPending).length || "";
          this.setState({ pendingCount });
          this.props.updateProfileInfoSuccess({ pendingSurveysCount: pendingCount });
        } else {
          pendingCount = surveyData.length > 0 ? surveyData.length : "";
          this.setState({ pendingCount });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleToggleChange = (newShowAll) => {
    this.setState({ showAll: newShowAll });
    this.retrieveMySubmittedQuizes(!newShowAll);
  };

  sortComponent = (key) => {
    return "";
  };

  handleTakeTrivvy = (trivia) => {
    this.props.history.push(
      `/home/trivia/${trivia.organizationId}/quiz/${trivia._id}/start`
    );
  };

  handleViewResult = (resultId, trivia) => {
    this.props.history.push(
      `/home/trivia/${trivia.organizationId}/quiz/${trivia._id}/result?resultId=${resultId}`
    );
  };

  getTrivvyInviteDate = (doc) => {
    const trivia = doc.triviaId;
    if (trivia.privacy == "ENTERPRISE") {
      return moment(doc.createdOn).format("MMM DD, YYYY");
    } else if (trivia.privacy == "CUSTOM") {
      const object = trivia.sharedWithUsers.find(
        (x) => (x.userId = this.props.user.profile._id)
      );

      if (object) {
        return moment(doc.createdOn).format("MMM DD, YYYY");
      } else {
        return moment(doc.createdOn).format("MMM DD, YYYY");
      }
    } else {
      return moment(doc.createdOn).format("MMM DD, YYYY");
    }
  };

  removePendingTrivvy = (item) => {
    this.setState({
      removeId: item._id,
    });
    axios
      .delete(url.removePendingTrivvy(item._id))
      .then(({ data }) => {
        this.setState({
          removeId: null,
        });
        const quizes = [...this.state.myPendingQuizes];

        const filtered = quizes.filter((x) => x._id != item._id);

        this.setState({ myPendingQuizes: [...filtered] });
      })
      .catch((err) => {
        this.setState({
          removeId: null,
        });
        console.log(err);
      });
  };

  renderRowOptions = (item) => {
    const { optionsPopover } = this.state;

    return (
      <div>
        <span
          id={`surveyResultRow_${item._id}`}
          onClick={() => this.setState({ optionsPopover: item._id })}
          className="cursor-pointer"
        >
          <BsThreeDots />
        </span>
        <Popover
          isOpen={item._id == optionsPopover}
          target={`surveyResultRow_${item._id}`}
          toggle={() => {
            this.setState({ optionsPopover: null });
          }}
          placement="bottom"
          hideArrow
          className="surveyListRow_Popover"
        >
          <PopoverBody className="">
            <div
              className={`dropdown-item my-1 cursor-pointer`}
              onClick={(e) => {
                if (item.isPending) {
                  this.handleTakeTrivvy(item.triviaId);
                } else {
                  this.handleViewResult(item._id, item.triviaId);
                }
              }}
            >
              {item.isPending ? 'Take Trivvy' : 'View result'}
            </div>
            {item.triviaMeta && item.triviaMeta.librarySummaryText ? (
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={(e) => {
                  this.setState({
                    customModalText: item.triviaMeta.librarySummaryText,
                    optionsPopover: null,
                  });
                }}
              >
                View summary
              </div>
            ) : (
              ""
            )}
          </PopoverBody>
        </Popover>
      </div>
    );
  };

  renderActionSection = (item) => {
    const { removeId } = this.state;
    if (
      item.triviaMeta &&
      item.triviaMeta.trivvyEndDate &&
      moment(item.triviaMeta.trivvyEndDate).isSameOrBefore(moment(), "day")
    ) {
      return (
        <div className="text-center pendingActionButtonSize">
          {removeId == item._id ? (
            <Button color="danger">Loading...</Button>
          ) : (
            <Button
              color="danger"
              onClick={() => {
                this.removePendingTrivvy(item);
              }}
            >
              Remove
            </Button>
          )}

          {/* <div className="font-11px text-center text-danger">
            Trivvy has ended and you are no longer able to take it
          </div> */}
        </div>
      );
    } else if (item.isTrivvyUnpublishedByAdmin) {
      return (
        <div className="text-center pendingActionButtonSize">
          <Button disabled>Paused</Button>
          {/* <div className="font-11px text-center text-warning">Trivvy is paused</div> */}
        </div>
      );
    } else {
      return (
        <div className="text-center pendingActionButtonSize">
          {/* <Button
            size="sm"
            onClick={() => this.handleTakeTrivvy(item.triviaId)}
            className="trivia-action-button-main"
          >
            Take trivvy
          </Button> */}
          {this.renderRowOptions(item)}
        </div>
      );
    }
  };

  render() {
    console.log("Pending Trivvy -- render");

    const { myPendingQuizes, customModalText } = this.state;
    const orgObject = this.props.user.profile.organizationId;
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType;
    const tableCols = {
      trivvyName: 4,
      endingOn: 2,
      invitedOn: 2,
      questions: trivvy_plan_type == "001" ? 2 : 1,
      action: 3,
      linkedRewards: 1,
    };

    const tableColsMobile = {
      endingOn: 3,
      invitedOn: 3,
      questions: trivvy_plan_type == "001" ? 2 : 2,
      action: 3,
      linkedRewards: 1,
    };

    const myTriviaHeaders = [
      {
        label: "Trivia Name",
        key: "name",
      },
      {
        label: "Invited on",
        key: "createdOn",
      },
      {
        label: "Ending on",
        key: "trivvyEndDate",
      },
      {
        label: "Questions",
        key: "totalQuestions",
      },
      // {
      //   label: "Rewards",
      //   key: "rewards",
      // },
    ];

    return (
      <div className="my-trivia-page">
        {customModalText && (
          <Modal isOpen={true}>
            <ModalHeader
              toggle={() => {
                this.setState({ customModalText: false });
              }}
              className="trivia_modal_header_bg"
            >
              Summary
            </ModalHeader>
            <ModalBody>{customModalText}</ModalBody>
          </Modal>
        )}
        {myPendingQuizes.length == -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={"No Surveys Found"}
              subtitle={"You dont have any trivvy pending."}
            />
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-start align-items-center mb-3 ml-4">
              <div className="d-flex justify-content-start align-items-center">
                <div className="trivvy-toggle-container">
                  <button
                    className={`trivvy-toggle-btn ${
                      this.state.showAll ? "active" : ""
                    }`}
                    onClick={() => this.handleToggleChange(true)}
                  >
                    All
                  </button>
                  <button
                    className={`trivvy-toggle-btn ${
                      !this.state.showAll ? "active" : ""
                    }`}
                    onClick={() => this.handleToggleChange(false)}
                  >
                    <span className="d-flex align-items-center">
                      Pending
                      {this.state.pendingCount > 0 && (
                        <span
                          className={`notification-dot ${
                            !this.state.showAll ? "inverted" : ""
                          }`}
                        >
                          {this.state.pendingCount}
                        </span>
                      )}
                    </span>
                  </button>
                </div>
              </div>

              <CSVLink
                data={this.getDataForExportResult()}
                headers={myTriviaHeaders}
                filename={`My Surveys - ${moment().format("MM/DD/YYYY")}.csv`}
                separator={","}
                target="_blank"
                className="ml-4 btn btn-sm trivia-action-button-main trivvy-export-table-btn"
                style={{
                  height: "fit-content",
                }}
              >
                {"Export to CSV"} <BsDownload size={13} />
              </CSVLink>
            </div>

            {!isMobile ? (
              <div>
                <div className="trivia_survey_list_table px-3">
                  <div className="my-4 trivia_survey_list_table_contents">
                    <LayoutRowShadow className="row-shadow-header-no-shadow">
                      {!isMobile && (
                        <LayoutHeadingShadowLeft
                          className={"text-left"}
                          colWidth={tableCols.trivvyName}
                        >
                          Name
                        </LayoutHeadingShadowLeft>
                      )}

                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.invitedOn}
                      >
                        Invited on
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.createdOn}
                      >
                        Ending on
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.questions}
                      >
                        Questions
                      </LayoutHeadingShadow>

                      {/* {trivvy_plan_type !== "001" && (
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.linkedRewards}
                        >
                          Rewards
                        </LayoutHeadingShadow>
                      )} */}

                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={tableCols.action}
                      ></LayoutHeadingShadow>
                    </LayoutRowShadow>
                    <div
                      className={`trivia_survey_list_table_contents_scroll pendingui ${
                        myPendingQuizes.length == 0 ? "trivvy-no-results" : ""
                      }`}
                      style={{
                        paddingTop: "30px",
                      }}
                    >
                      {!isMobile && myPendingQuizes.length > 0 ? (
                        myPendingQuizes.map((item, idx) => {
                          let itm_color = idx % 2 == 0 ? "#ff6233" : "#c6ffe7";

                          const isPaused = item.isTrivvyUnpublishedByAdmin;
                          const isEnded =
                            item.triviaMeta &&
                            item.triviaMeta.trivvyEndDate &&
                            moment(
                              item.triviaMeta.trivvyEndDate
                            ).isSameOrBefore(moment(), "day");

                          const pausedDate = item.triviaId
                            ? item.triviaId.pausedDate
                              ? item.triviaId.pausedDate
                              : item.triviaId.unpublishedDate
                              ? item.triviaId.unpublishedDate
                              : null
                            : null;
                          return (
                            <div className={`p-relative`}>
                              {isEnded ? (
                                <div className="endTrivvyRowTag">
                                  This Trivvy ended on{" "}
                                  {moment(item.triviaMeta.trivvyEndDate).format(
                                    "MMM DD, YYYY"
                                  )}{" "}
                                  by your Admin
                                </div>
                              ) : isPaused ? (
                                <div className="pauseTrivvyRowTag">
                                  This Trivvy was paused by your Admin{" "}
                                  {pausedDate
                                    ? `on ${moment(pausedDate).format(
                                        "MMM DD, YYYY"
                                      )}`
                                    : ""}
                                  .
                                </div>
                              ) : (
                                ""
                              )}
                              <LayoutRowShadow
                                key={idx}
                                // className={`${
                                //   isPaused || isEnded ? "opacity-p2" : ""
                                // }`}
                              >
                                <LayoutData
                                  colWidth={tableCols.trivvyName}
                                  className={`px-3 text-center ${
                                    item.isPending
                                      ? "cursor-pointer"
                                      : "text-muted"
                                  }`}
                                  style={{
                                    opacity: item.isPending ? 1 : 0.5,
                                  }}
                                >
                                  <div
                                    className="d-flex"
                                    onClick={(e) => {
                                      if (item.isPending) {
                                        this.handleTakeTrivvy(item.triviaId);
                                      }
                                    }}
                                    style={{
                                      pointerEvents: item.isPending ? "auto" : "none",
                                    }}
                                  >
                                    <span
                                      className="trivia-list-item-color-chip"
                                      style={{ backgroundColor: itm_color }}
                                    />
                                    <div
                                    // style={{ flex: 1 }}
                                    >
                                      <div className="survey-item-title-itm">
                                        <span
                                          // onClick={() => this.redirectToSurveyPage(item)}
                                          className="survey-item-title"
                                        >
                                          {item.triviaId
                                            ? item.triviaId.name
                                            : "-"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.invitedOn}
                                  className={`text-center ${
                                    isPaused || isEnded ? "opacity-p2" : ""
                                  }`}
                                >
                                  {this.getTrivvyInviteDate(item)}
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.endingOn}
                                  className={`text-center ${
                                    isPaused || isEnded ? "opacity-p2" : ""
                                  }`}
                                >
                                  {item.triviaId &&
                                  item.triviaId.trivvyEndDate ? (
                                    moment(item.triviaId.trivvyEndDate).format(
                                      "MMM DD, YYYY"
                                    )
                                  ) : (
                                    <LuCalendarCheck size={20} />
                                  )}
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.questions}
                                  className={`text-center ${
                                    isPaused || isEnded ? "opacity-p2" : ""
                                  }`}
                                >
                                  {item.triviaId && item.triviaId.questions
                                    ? item.triviaId.questions.length
                                    : ""}
                                </LayoutData>
                                {/* {trivvy_plan_type !== "001" && (
                                  <LayoutData
                                    className={`text-center ${
                                      isPaused || isEnded ? "opacity-p2" : ""
                                    }`}
                                    colWidth={tableCols.linkedRewards}
                                  >
                                    {item.triviaId &&
                                    item.triviaId.linkedRewards &&
                                    item.triviaId.linkedRewards.length ? (
                                      <GiOpenTreasureChest className="reward-icon-color reward-icon-size" />
                                    ) : (
                                      <GiOpenTreasureChest
                                        className="reward-icon-size"
                                        color="grey"
                                      />
                                    )}
                                  </LayoutData>
                                )} */}
                                <LayoutData
                                  colWidth={tableCols.action}
                                  className="text-center"
                                >
                                  {this.renderActionSection(item)}
                                </LayoutData>{" "}
                              </LayoutRowShadow>
                            </div>
                          );
                        })
                      ) : (
                        <span>No Surveys</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="trivia_table_mobile mt-4 px-2">
                <div className="trivia_survey_list_table_contents_scroll">
                  <Row>
                    <Col xs={5} className="px-0">
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={12}
                      >
                        Name
                      </LayoutHeadingShadow>

                      {myPendingQuizes.length == 0 ? (
                        <Row
                          className={
                            "planning-row-mobile-height layout-row-shadow mx-0"
                          }
                        >
                          <LayoutData colWidth={12}>No Surveys</LayoutData>
                        </Row>
                      ) : (
                        ""
                      )}

                      {myPendingQuizes.map((item, idx) => {
                        const isPaused = item.isTrivvyUnpublishedByAdmin;
                        const isEnded =
                          item.triviaMeta &&
                          item.triviaMeta.trivvyEndDate &&
                          moment(item.triviaMeta.trivvyEndDate).isSameOrBefore(
                            moment(),
                            "day"
                          );

                        return (
                          <LayoutRowLines
                            key={idx}
                            className={"planning-row-mobile-height mx-0 px-0"}
                          >
                            <LayoutDataLines noFlex colWidth={12}>
                              <div
                                className={`${
                                  item.isPending
                                    ? "cursor-pointer text-info"
                                    : "text-muted"
                                }`}
                                onClick={() =>
                                  item.isPending
                                    ? this.handleTakeTrivvy(item.triviaId)
                                    : null
                                }
                                style={{
                                  pointerEvents: item.isPending ? "auto" : "none",
                                  opacity: item.isPending ? 1 : 0.5,
                                }}
                              >
                                <div className="survey-item-title-itm">
                                  <span className="survey-item-title">
                                    {item.triviaId ? item.triviaId.name : "-"}
                                  </span>
                                </div>
                              </div>
                              <ReactTooltip />
                            </LayoutDataLines>
                          </LayoutRowLines>
                        );
                      })}
                    </Col>

                    <Col xs={7} className="scrollable-action-table-row px-0">
                      <LayoutRowLines className="row-scroll-width-s">
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableColsMobile.invitedOn}
                        >
                          Invited on
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableColsMobile.endingOn}
                        >
                          Ending on
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableColsMobile.questions}
                        >
                          Questions
                        </LayoutHeadingShadow>

                        {/* {trivvy_plan_type !== "001" && (
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.linkedRewards}
                          >
                            Rewards
                          </LayoutHeadingShadow>
                        )} */}

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableColsMobile.action}
                        ></LayoutHeadingShadow>
                      </LayoutRowLines>

                      {myPendingQuizes.map((item, idx) => {
                        const isPaused = item.isTrivvyUnpublishedByAdmin;
                        const isEnded =
                          item.triviaMeta &&
                          item.triviaMeta.trivvyEndDate &&
                          moment(item.triviaMeta.trivvyEndDate).isSameOrBefore(
                            moment(),
                            "day"
                          );

                        const pausedDate = item.triviaId
                          ? item.triviaId.pausedDate
                            ? item.triviaId.pausedDate
                            : item.triviaId.unpublishedDate
                            ? item.triviaId.unpublishedDate
                            : null
                          : null;

                        if (isEnded || isPaused) {
                          return (
                            <LayoutRowLines
                              key={idx}
                              className={`pl-tasks-row ${
                                isMobile ? "row-scroll-width-s" : ""
                              }`}
                            >
                              <LayoutData colWidth={9} className="text-center">
                                {isEnded ? (
                                  <div
                                    className="endTrivvyRowTag"
                                    style={{ position: "relative" }}
                                  >
                                    This Trivvy ended on{" "}
                                    {moment(
                                      item.triviaMeta.trivvyEndDate
                                    ).format("MMM DD, YYYY")}{" "}
                                    by your Admin
                                  </div>
                                ) : isPaused ? (
                                  <div
                                    className="pauseTrivvyRowTag"
                                    style={{ position: "relative" }}
                                  >
                                    This Trivvy was paused by your Admin{" "}
                                    {pausedDate
                                      ? `on ${moment(pausedDate).format(
                                          "MMM DD, YYYY"
                                        )}`
                                      : ""}
                                    .
                                  </div>
                                ) : (
                                  ""
                                )}
                              </LayoutData>{" "}
                              <LayoutData
                                colWidth={tableColsMobile.action}
                                className="text-center"
                              >
                                {this.renderActionSection(item)}
                              </LayoutData>{" "}
                            </LayoutRowLines>
                          );
                        } else {
                          return (
                            <div>
                              <LayoutRowLines
                                key={idx}
                                className={`pl-tasks-row ${
                                  isMobile ? "row-scroll-width-s" : ""
                                }`}
                              >
                                <LayoutDataLines
                                  colWidth={tableColsMobile.invitedOn}
                                  className="text-center font-13px"
                                >
                                  {this.getTrivvyInviteDate(item)}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  colWidth={tableColsMobile.endingOn}
                                  className="text-center font-13px"
                                >
                                  {item.triviaId &&
                                  item.triviaId.trivvyEndDate ? (
                                    moment(item.triviaId.trivvyEndDate).format(
                                      "MMM DD, YYYY"
                                    )
                                  ) : (
                                    <LuCalendarCheck size={20} />
                                  )}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  colWidth={tableColsMobile.questions}
                                  className="text-center font-13px"
                                >
                                  {item.triviaId && item.triviaId.questions
                                    ? item.triviaId.questions.length
                                    : ""}
                                </LayoutDataLines>
                                {/* {trivvy_plan_type !== "001" && (
                                  <LayoutDataLines
                                    className="text-center"
                                    colWidth={tableColsMobile.linkedRewards}
                                  >
                                    {item.triviaId &&
                                    item.triviaId.linkedRewards &&
                                    item.triviaId.linkedRewards.length ? (
                                      <GiOpenTreasureChest className="reward-icon-color reward-icon-size" />
                                    ) : (
                                      <GiOpenTreasureChest
                                        className="reward-icon-size"
                                        color="grey"
                                      />
                                    )}
                                  </LayoutDataLines>
                                )} */}
                                <LayoutData
                                  colWidth={tableColsMobile.action}
                                  className="text-center"
                                >
                                  {this.renderActionSection(item)}
                                </LayoutData>{" "}
                              </LayoutRowLines>
                            </div>
                          );
                        }
                      })}
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.myTrivia
        ? state.sortFilterParams.myTrivia.sort &&
          state.sortFilterParams.myTrivia.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.myTrivia.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) =>
      dispatch(actionCreators.updateMyTriviaSort(data)),
    updateProfileInfoSuccess: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios));
